import script from "./dictionaryList.vue?vue&type=script&setup=true&lang=js"
export * from "./dictionaryList.vue?vue&type=script&setup=true&lang=js"

import "./dictionaryList.vue?vue&type=style&index=0&id=255a2af2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-255a2af2"]])

export default __exports__